import { instanceBin } from '@payments-checkout/shared/helpers/service/bin.instance.service';
import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { useEffect } from 'react';

async function getCardFlagBysixFirstCardNumber(sixFirstCardNumber: string) {
  const response = await instanceBin.get<any>(`/${sixFirstCardNumber}`);
  return response;
}

const useBin = (sixFirstCardNumber: string) => {
  const { setBrand, setIsBrandReady } = usePaymentMethod();
  const query = useQuery<AxiosResponse<any>, AxiosError>({
    queryKey: ['getCardFlag', sixFirstCardNumber],
    queryFn: () => getCardFlagBysixFirstCardNumber(sixFirstCardNumber),
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    enabled: false,
    retry: false,
  });

  useEffect(() => {
    if (query.isFetched) {
      setIsBrandReady && setIsBrandReady(query.isFetched);
      setBrand && setBrand(query?.data?.data?.brand || 'DEFAULT');
    }
    if (query.isError) {
      setIsBrandReady && setIsBrandReady(query.isFetched);
      setBrand && setBrand('DEFAULT');
    }
    if (query.isRefetching) {
      setIsBrandReady && setIsBrandReady(query.isRefetching);
      setBrand && setBrand('DEFAULT');
    }
  }, [query.isFetched, query.isRefetching, query.isError]);

  return { ...query, data: query.data?.data };
};

export { getCardFlagBysixFirstCardNumber, useBin };
